<template>
  <v-card outlined class="ma-0 pa-0" style="overflow-x: hidden">
    <v-row justify="center" align="center" class="ma-1">
      <v-spacer></v-spacer>
      <span class="title">Настройки</span>
      <v-spacer></v-spacer>
      <v-btn color="error" text fab small @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-row>
    <v-row justify="center" class="ma-0">
      <v-divider></v-divider>
    </v-row>
    <div class="pa-2">
      <v-row justify="center">
        <v-col class="mt-2" lg="6" md="6" sm="6" cols="12">
          <template v-if="currentArticleLimit == articleLimits[1]">
            <v-row class="ma-0 pa-0">
              <v-col class="ma-0 pa-0" lg="6" md="6" sm="6" cols="12">
                <v-select class="ma-0 pa-1 pb-3" dense v-model="currentArticleLimit" :items="articleLimits" hide-details label="Брой артикули"></v-select>
              </v-col>
              <v-col class="ma-0 pa-0" lg="3" md="3" sm="3" cols="6">
                <v-text-field class="ma-0 pa-1 pb-3" v-model.number="currentArticleFrom" label="От" dense hide-details></v-text-field>
              </v-col>
              <v-col class="ma-0 pa-0" lg="3" md="3" sm="3" cols="6">
                <v-text-field class="ma-0 pa-1 pb-3" v-model.number="currentArticleTo" label="До" dense hide-details></v-text-field>
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <v-select class="ma-0 pa-1 pb-3" dense v-model="currentArticleLimit" :items="articleLimits" hide-details label="Брой артикули"></v-select>
          </template>

          <v-select class="ma-0 pa-1 pb-3" dense v-model="currentClientsLimit" :items="clientsLimit" hide-details label="Брой клиенти"></v-select>
          <v-switch class="ma-0 pa-1" color="#1685c9" inset v-model="currentVatInReceipt" hide-details :label="`Печат на ДДС`"></v-switch>
          <v-switch class="ma-0 pa-1" color="#1685c9" inset v-model="currentDetailedReceipt" hide-details :label="`Печат на единично количество`"></v-switch>
          <v-switch class="ma-0 pa-1 pb-6" color="#1685c9" inset v-model="closeAfterPayment" hide-details :label="`Затваряне на бона след плащане`"></v-switch>

          <v-row class="ma-0 pa-0 pb-3">
            <v-col class="ma-0 pa-0 mt-2" lg="8" md="7" sm="12" cols="12">
              <v-select class="ma-0 pa-1" v-model="currentScaleType" :items="scaleTypeValues" label="Търговска везна" dense hide-details></v-select>
            </v-col>
            <v-col class="ma-0 pa-0 mt-2" lg="4" md="5" sm="12" cols="12">
              <v-combobox :disabled="currentScaleType == scaleTypes.NONE || currentScaleType == scaleTypes.SCALE_ON_FD" class="ma-0 pa-1" v-model="currentScalePort" :items="serialPorts" label="Порт везна (9600)" dense hide-details></v-combobox>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0 pb-3">
            <v-col class="ma-0 pa-0 mt-2" lg="8" md="7" sm="12" cols="12">
              <v-select class="ma-0 pa-1" v-model="currentExternalDisplayCodePage" :items="codePages" label="Дисплей / кодова таблица" dense hide-details></v-select>
            </v-col>
            <v-col class="ma-0 pa-0 mt-2" lg="4" md="5" sm="12" cols="12">
              <v-combobox :disabled="!currentExternalDisplayCodePage" class="ma-0 pa-1" v-model="currentExternalDisplayPort" :items="serialPorts" label="Порт дисплей (9600)" dense hide-details></v-combobox>
            </v-col>
          </v-row>

          <!-- <v-switch v-if="!isOnMobile" class="ma-0 pa-1" color="success" inset v-model="showCloseBarcode" hide-details label="Баркод за затваряне на бон"></v-switch> -->
        </v-col>

        <v-col class="mt-2" lg="6" md="6" sm="6" cols="12">
          <v-switch class="ma-0 pa-1" color="#1685c9" inset v-model="darkMode" hide-details label="Тъмен режим"></v-switch>
          <v-switch class="ma-0 pa-1" color="#1685c9" inset v-model="touchScreenMode" hide-details label="Тъч скрийн режим"></v-switch>
          <v-switch v-if="!isOnMobile" class="ma-0 pa-1" color="#1685c9" inset v-model="uiMenuInLeft" hide-details label="Продажби - меню в ляво"></v-switch>
          <v-switch class="ma-0 pa-1" color="#1685c9" inset v-model="searchInTop" hide-details label="Продажби - търсене отгоре"></v-switch>
          <v-switch v-if="!isOnMobile && !isOnAndroid" class="ma-0 pa-1" color="#1685c9" inset v-model="showPaymentValues" hide-details :label="`Покажи номинали при плащане`"></v-switch>
          <v-switch v-if="!isOnMobile && !isOnAndroid" class="ma-0 pa-1" color="#1685c9" inset v-model="showDrawerButton" hide-details :label="`Покажи бутон за чекмедже`"></v-switch>
          <v-switch v-if="!isOnMobile && !isOnAndroid" class="ma-0 pa-1" color="#1685c9" inset v-model="showFreePrice" hide-details :label="`Работа със свободна цена`"></v-switch>
          <v-switch class="ma-0 pa-1 pt-6" color="#1685c9" inset v-model="noFullScreen" hide-details label="Без изглед на цял екран"></v-switch>
          <v-switch class="ma-0 pa-1" color="#1685c9" inset v-model="noConfirmOnKeyboardSale" hide-details label="Без потвърждение при продажба от клавиатура"></v-switch>
          <v-select class="ma-0 pa-1 pt-6" dense v-model="currentViewType" :items="viewTypes" hide-details label="Изглед на артикулите"></v-select>
        </v-col>
      </v-row>
      <v-row justify="center" v-if="!isOnAndroid">
        <v-col class="mt-2" lg="6" md="6" sm="6" cols="12"> </v-col>
      </v-row>
    </div>
  </v-card>
</template>
<script>
import Const from "../constants";
import Tremol from "../assets/fp/fp";

export default {
  props: {},
  components: {},
  data() {
    return {
      viewTypes: Const.ViewTypes,
      scaleTypes: Const.ScaleTypes,
      scaleTypeValues: Object.values(Const.ScaleTypes),
      articleLimits: Const.ArticleLimits,
      clientsLimit: Const.ClientsLimits,
    };
  },
  computed: {
    serialPorts() {
      return ["", ...Const.SerialPortNames];
    },
    codePages() {
      return ["", ...Const.CodePages];
    },
    /** @return {Boolean} */
    darkMode: {
      get() {
        return this.$vuetify.theme.dark;
      },
      set(newValue) {
        localStorage.setItem(Const.Theme, newValue.toString());
        this.$vuetify.theme.dark = newValue;
      },
    },
    uiMenuInLeft: {
      get() {
        return this.uiSettings.menuInLeft;
      },
      set(newValue) {
        localStorage.setItem(Const.SettingsMenuInLeft, newValue.toString());
        this.uiSettings.menuInLeft = newValue;
      },
    },

    /** @return {Boolean} */
    closeAfterPayment: {
      get() {
        return this.uiSettings.closeAfterPayment;
      },
      set(newValue) {
        localStorage.setItem(Const.SettingsCloseReceiptAfterPayment, newValue.toString());
        this.uiSettings.closeAfterPayment = newValue;
      },
    },
    /** @return {Boolean} */
    showCloseBarcode: {
      get() {
        return this.uiSettings.showCloseBarcode;
      },
      set(newValue) {
        localStorage.setItem(Const.SettingsShowCloseReceiptBarcode, newValue.toString());
        this.uiSettings.showCloseBarcode = newValue;
      },
    },
    /** @return {Boolean} */
    searchInTop: {
      get() {
        return this.uiSettings.searchInTop;
      },
      set(newValue) {
        localStorage.setItem(Const.SettingsSearchInTop, newValue.toString());
        this.uiSettings.searchInTop = newValue;
      },
    },
    /** @return {Boolean} */
    noFullScreen: {
      get() {
        return this.uiSettings.noFullScreen;
      },
      set(newValue) {
        localStorage.setItem(Const.SettingsNoFullScreen, newValue.toString());
        this.uiSettings.noFullScreen = newValue;
      },
    },
    /** @return {Boolean} */
    touchScreenMode: {
      get() {
        return this.uiSettings.touchScreenMode;
      },
      set(newValue) {
        localStorage.setItem(Const.SettingsTouchScreenMode, newValue.toString());
        this.uiSettings.touchScreenMode = newValue;
      },
    },
    currentScaleType: {
      get() {
        return this.uiSettings.scaleType;
      },
      set(newValue) {
        if (newValue) {
          localStorage.setItem(Const.ScaleType, newValue);
          if (newValue == Const.ScaleTypes.SCALE_ON_FD) {
            this.currentScalePort = "";
          }
        } else {
          localStorage.setItem(Const.ScaleType, "");
          this.currentScalePort = "";
        }
        this.uiSettings.scaleType = newValue;
        this.fp.scaleType = newValue;
      },
    },
    currentScalePort: {
      get() {
        return this.uiSettings.scalePort;
      },
      set(newValue) {
        if (newValue && localStorage.getItem(Const.DeviceIsWorkingOnSerialPort) && localStorage.getItem(Const.DeviceSerialPortName) == newValue) {
          this.fp.setErrorMessage("На посоченият сериен порт е настроено ФУ!");
          this.$nextTick(() => {
            this.currentScalePort = "";
          });
        } else if (newValue && localStorage.getItem(Const.ExternalDisplayPortName) == newValue) {
          this.fp.setErrorMessage("На посоченият сериен порт е настроен външен дисплей!");
          this.$nextTick(() => {
            this.currentScalePort = "";
          });
        } else {
          localStorage.setItem(Const.ScalePortName, newValue);
          this.uiSettings.scalePort = newValue;
          this.fp.scalePort = newValue;
        }
      },
    },
    currentExternalDisplayPort: {
      get() {
        return this.uiSettings.externalDisplayPort;
      },
      set(newValue) {
        if (newValue && localStorage.getItem(Const.DeviceIsWorkingOnSerialPort) && localStorage.getItem(Const.DeviceSerialPortName) == newValue) {
          this.fp.setErrorMessage("На посоченият сериен порт е настроено ФУ!");
          this.$nextTick(() => {
            this.$nextTick(() => {
              this.currentExternalDisplayPort = "";
            });
          });
        } else if (newValue && localStorage.getItem(Const.ScalePortName) == newValue) {
          this.fp.setErrorMessage("На посоченият сериен порт е настроена везна!");
          this.$nextTick(() => {
            this.$nextTick(() => {
              this.currentExternalDisplayPort = "";
            });
          });
        } else {
          localStorage.setItem(Const.ExternalDisplayPortName, newValue);
          this.uiSettings.externalDisplayPort = newValue;
          this.fp.externalDisplayPort = newValue;
        }
      },
    },
    currentExternalDisplayCodePage: {
      get() {
        return this.uiSettings.externalDisplayCodePage;
      },
      set(newValue) {
        if (newValue) {
          localStorage.setItem(Const.ExternalDisplayCodePage, newValue.toString());
        } else {
          localStorage.setItem(Const.ExternalDisplayCodePage, "");
          this.currentExternalDisplayPort = "";
        }

        this.uiSettings.externalDisplayCodePage = newValue;
        this.fp.externalDisplayCodePage = newValue;
      },
    },

    /** @return {Boolean} */
    showPaymentValues: {
      get() {
        return this.uiSettings.showPaymentValues;
      },
      set(newValue) {
        localStorage.setItem(Const.SettingsShowPaymentValues, newValue.toString());
        this.uiSettings.showPaymentValues = newValue;
      },
    },
    /** @return {Boolean} */
    noConfirmOnKeyboardSale: {
      get() {
        return this.uiSettings.noConfirmOnKeyboardSale;
      },
      set(newValue) {
        localStorage.setItem(Const.SettingsNoConfirmOnKeyboardSale, newValue.toString());
        this.uiSettings.noConfirmOnKeyboardSale = newValue;
      },
    },
    showFreePrice : {
      get() {
        return this.uiSettings.showFreePrice;
      },
      set(newValue) {
        localStorage.setItem(Const.SettingsShowFreePrice, newValue.toString());
        this.uiSettings.showFreePrice = newValue;
      },
    },
    showDrawerButton: {
      get() {
        return this.uiSettings.showDrawerButton;
      },
      set(newValue) {
        localStorage.setItem(Const.SettingsShowDrawer, newValue.toString());
        this.uiSettings.showDrawerButton = newValue;
      },
    },
    /** @return {String} */
    currentViewType: {
      get() {
        return this.uiSettings.viewType;
      },
      set(newValue) {
        localStorage.setItem(Const.CurrentViewType, newValue.toString());
        this.uiSettings.viewType = newValue;
      },
    },
    /** @return {String} */
    currentArticleLimit: {
      get() {
        return this.uiSettings.articleLimit;
      },
      set(newValue) {
        localStorage.setItem(Const.CurrentArticleLimit, newValue.toString());
        this.uiSettings.articleLimit = newValue;
      },
    },
    /** @return {Number} */
    currentArticleFrom: {
      get() {
        return this.uiSettings.articleFrom;
      },
      set(newValue) {
        localStorage.setItem(Const.CurrentArticleFrom, newValue.toString());
        this.uiSettings.articleFrom = newValue;
      },
    },
    /** @return {Number} */
    currentArticleTo: {
      get() {
        return this.uiSettings.articleTo;
      },
      set(newValue) {
        localStorage.setItem(Const.CurrentArticleTo, newValue.toString());
        this.uiSettings.articleTo = newValue;
      },
    },
    /** @return {String} */
    currentClientsLimit: {
      get() {
        return this.uiSettings.clientsLimit;
      },
      set(newValue) {
        localStorage.setItem(Const.CurrentClientsLimit, newValue.toString());
        this.uiSettings.clientsLimit = newValue;
      },
    },
    /** @return {Boolean} */
    currentVatInReceipt: {
      get() {
        return this.uiSettings.printVatInReceipt == Tremol.Enums.OptionPrintVAT.Yes;
      },
      set(newValue) {
        if (newValue) {
          localStorage.setItem(Const.PrintVatInReceipt, Tremol.Enums.OptionPrintVAT.Yes);
          this.uiSettings.printVatInReceipt = Tremol.Enums.OptionPrintVAT.Yes;
        } else {
          localStorage.setItem(Const.PrintVatInReceipt, Tremol.Enums.OptionPrintVAT.No);
          this.uiSettings.printVatInReceipt = Tremol.Enums.OptionPrintVAT.No;
        }
      },
    },
    /** @return {Boolean} */
    currentDetailedReceipt: {
      get() {
        return this.uiSettings.receiptFormat == Tremol.Enums.OptionReceiptFormat.Detailed;
      },
      set(newValue) {
        if (newValue) {
          localStorage.setItem(Const.ReceiptFormat, Tremol.Enums.OptionReceiptFormat.Detailed);
          this.uiSettings.receiptFormat = Tremol.Enums.OptionReceiptFormat.Detailed;
        } else {
          localStorage.setItem(Const.ReceiptFormat, Tremol.Enums.OptionReceiptFormat.Brief);
          this.uiSettings.receiptFormat = Tremol.Enums.OptionReceiptFormat.Brief;
        }
      },
    },
  },
  methods: {
    close() {
      this.fp.exitMode(Const.Modes.Settings);
    },
  },
  mounted() {
    if (localStorage.getItem(Const.CurrentArticleLimit) == null) {
      localStorage.setItem(Const.CurrentArticleLimit, Const.ArticleLimits[1]);
    }
    if (localStorage.getItem(Const.CurrentArticleFrom) == null) {
      localStorage.setItem(Const.CurrentArticleFrom, 1);
    }
    if (localStorage.getItem(Const.CurrentArticleTo) == null) {
      localStorage.setItem(Const.CurrentArticleTo, 500);
    }
    if (localStorage.getItem(Const.CurrentViewType) == null) {
      localStorage.setItem(Const.CurrentViewType, Const.ViewTypes[1]);
    }
    if (localStorage.getItem(Const.SettingsMenuInLeft) == null) {
      localStorage.setItem(Const.SettingsMenuInLeft, "false");
    }
    if (localStorage.getItem(Const.SettingsSearchInTop) == null) {
      localStorage.setItem(Const.SettingsSearchInTop, "false");
    }
    if (localStorage.getItem(Const.SettingsCloseReceiptAfterPayment) == null) {
      localStorage.setItem(Const.SettingsCloseReceiptAfterPayment, "true");
    }
    if (localStorage.getItem(Const.PrintVatInReceipt) == null) {
      localStorage.setItem(Const.PrintVatInReceipt, Tremol.Enums.OptionPrintVAT.No);
    }
    if (localStorage.getItem(Const.ReceiptFormat) == null) {
      localStorage.setItem(Const.ReceiptFormat, Tremol.Enums.OptionReceiptFormat.Brief);
    }
  },
  destroyed() {},
  beforeDestroy() {
    this.fp.addMode(Const.Modes.Sales);
  },
};
</script>

<style scoped>
.v-input >>> .v-label {
  font-size: 14px;
}
</style>